import React, { useEffect, useState, useRef } from 'react';
import SimpleAlert from '../components/SimpleAlert';
import moment from "moment/moment";

import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from 'react-pdf';
import DocumentFileViewer from '../components/DocmentFileViewer';

// 正确配置Worker路径，版本号一致
pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;



export default function AdminOrderDetail({ id, onBack, onEdit }) {
  const [order, setOrder] = useState(null);
  const [alert, setAlert] = useState({ open: false, message: '', onConfirm: null });
  const [files, setFiles] = useState([]);
  const [signfiles, setsignFiles] = useState([]);
  const [fileItem, setFileItem] = useState("");
    const [fileItemShow, setFileItemShow] = useState(false);
    const [fileType, setFileType] = useState('pdf');
    const pdfForPreview = useRef();
/*  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    fetch(`/api/admin/orderDetail/${id}`, {
      headers: { Authorization: 'Bearer ' + token }
    })
      .then(res => {
        if (res.status === 401 || res.status === 403) {
          setAlert({ open: true, message: '您没有权限执行此操作' });
          return null;
        }
        return res.json();
      })
      .then(data => { if (data) setOrder(data); })
  }, [id]);*/
  useEffect(() => {
    const token = localStorage.getItem('adminToken');

    // 添加加载状态（可选）
    // setIsLoading(true);

    fetch(`/api/admin/orderDetail/${id}`, {
      headers: { Authorization: 'Bearer ' + token }
    })
        .then(res => {
          if (res.status === 401 || res.status === 403) {
            setAlert({ open: true, message: '您没有权限执行此操作' });
            throw new Error('无权限访问');
          }
          return res.json();
        })
        .then(data => {
          if (!data) return;

          // 设置文件列表
          setsignFiles(data.fileList);
          // 设置订单数据
          setOrder(data);

          // 构建文件列表
          const fileList = [];

          // 情况说明文件
          if (data.situationChecked && data.situationUrl) {
            fileList.push({
              fileUrl: data.situationUrl,
              fileName: data.situationName || '情况说明文件',
              fileType: '情况说明',
            });
          }

          // 股东会决议文件
          if (data.resolutionChecked && data.resolutionUrl) {
            fileList.push({
              fileUrl: data.resolutionUrl,
              fileName: data.resolutionName || '股东会决议文件',
              fileType: '股东会决议',
            });
          }

          // 自定义文件1
          if (data.customize1Checked && data.customize1Url) {
            fileList.push({
              fileUrl: data.customize1Url,
              fileName: data.customize1Name || '自定义文件1',
              fileType: '自定义文件1',
            });
          }

          // 自定义文件2
          if (data.customize2Checked && data.customize2Url) {
            fileList.push({
              fileUrl: data.customize2Url,
              fileName: data.customize2Name || '自定义文件2',
              fileType: '自定义文件2',
            });
          }

          // 设置文件列表
          setFiles(fileList);
        })
        .catch(error => {
          console.error('获取订单详情出错:', error);
          if (error.message !== '无权限访问') {
            setAlert({ open: true, message: '获取订单详情失败，请稍后重试' });
          }
        })
        .finally(() => {
          // 结束加载状态（可选）
          // setIsLoading(false);
        });
  }, [id]);

  if (!order) return <div>加载中...</div>;

  const handleCloseOrder = async () => {
    // 检查已核验通过股权比例
    const verifiedRatio = parseFloat(order.verified_share_ratio?.replace('%', '') || '0');
    if (verifiedRatio < 51) {
      setAlert({ open: true, message: '已核验通过股权比例低于51%，无法结单' });
      return;
    }

    const token = localStorage.getItem('adminToken');
    try {
      const res = await fetch(`/api/admin/closeOrder/${id}`, {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token }
      });
      if (res.status === 401 || res.status === 403) {
        setAlert({ open: true, message: '您没有权限执行此操作' });
        return;
      }
      const data = await res.json();
      setAlert({ open: true, message: data.message, onConfirm: () => onBack() });
    } catch (e) {
      setAlert({ open: true, message: '请求失败，请稍后重试' });
    }
  };

  const handleSendSms = async () => {
    const token = localStorage.getItem('adminToken');

    try {
      // 先查询短信发送统计信息
      const statsRes = await fetch(`/api/admin/orders/${id}/smsStats`, {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (!statsRes.ok) throw new Error('查询短信统计失败');

      const stats = await statsRes.json();

      // 格式化最后发送时间（中文格式）
      const lastTime = stats.last_sms_sent_at
        ? (() => {
            const d = new Date(stats.last_sms_sent_at);
            const pad = n => n.toString().padStart(2, '0');
            return `${d.getFullYear()}年${pad(d.getMonth() + 1)}月${pad(d.getDate())}日${pad(d.getHours())}时${pad(d.getMinutes())}分${pad(d.getSeconds())}秒`;
          })()
        : '从未发送';

      // 接收人列表
      const receivers = (stats.sms_receivers || '')
        .split('\n')
        .filter(Boolean)
        .join(', ');

      const proceedSend = async () => {
        try {
          const res = await fetch(`/api/admin/sendSms`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token
            },
            body: JSON.stringify({ id })
          });
          if (res.status === 401 || res.status === 403) {
            setAlert({ open: true, message: '您没有权限执行此操作' });
            return;
          }
          const data = await res.json();
          setAlert({ open: true, message: data.message });
        } catch (err) {
          setAlert({ open: true, message: err.message || '请求失败，请稍后重试' });
        }
      };

      if ((stats.sms_sent_count || 0) > 0) {
        const confirmText = `通知短信已发送过 ${stats.sms_sent_count} 次，共 ${stats.sms_total_messages || 0} 条。\n上次发送是： ${lastTime} 。\n接收号码有：${receivers || '暂无'}\n\n是否继续发送通知短信？`;
        setAlert({ open: true, message: confirmText, onConfirm: proceedSend });
      } else {
        await proceedSend();
      }
    } catch (e) {
      setAlert({ open: true, message: e.message || '请求失败，请稍后重试' });
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{
      margin: '0 auto',
      padding: 'clamp(16px, 4vw, 20px)',
      fontFamily: 'Arial, sans-serif',
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box'
    }}>
      {/* 返回按钮 */}
      <div style={{
        marginBottom: 'clamp(16px, 4vw, 20px)'
      }}>
        <button
          onClick={onBack}
          style={{
            background: '#6c757d',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: 'clamp(8px, 2vw, 12px) clamp(12px, 3vw, 16px)',
            cursor: 'pointer',
            fontSize: 'clamp(14px, 3vw, 16px)'
          }}
        >
          返回
        </button>
      </div>
        {/* 标题区域 */}
        <div style={{
          textAlign: 'center',
          marginBottom: 'clamp(20px, 5vw, 30px)',
          borderBottom: '2px solid #6f42c1',
          paddingBottom: 'clamp(12px, 3vw, 20px)'
        }}>
          <h1 style={{
            color: '#6f42c1',
            margin: '0 0 clamp(8px, 2vw, 10px) 0',
            fontSize: 'clamp(18px, 4vw, 24px)',
            fontWeight: 'bold'
          }}>
            重庆市联合印章刻制服务中心
          </h1>
          <h2 style={{
            color: '#6f42c1',
            margin: '0',
            fontSize: 'clamp(18px, 3.5vw, 23px)',
            fontWeight: 'bold'
          }}>
            印章业务授权管理系统
          </h2>
          <div style={{
            display: 'inline-block',
            background: '#6f42c1',
            color: '#fff',
            padding: 'clamp(3px, 1vw, 4px) clamp(8px, 2vw, 12px)',
            borderRadius: '12px',
            fontSize: 'clamp(10px, 2.5vw, 12px)',
            marginTop: 'clamp(6px, 1.5vw, 8px)'
          }}>
            管理端
          </div>
        </div>

        {/* 整合信息区域 */}
        <div style={{
          background: '#f8f9fa',
          borderRadius: '8px',
          padding: 'clamp(12px, 3vw, 16px)',
          marginBottom: 'clamp(12px, 3vw, 16px)',
          border: '1px solid #e9ecef'
        }}>
          <h3 style={{
            color: '#495057',
            margin: '0 0 clamp(8px, 2vw, 12px) 0',
            fontSize: 'clamp(16px, 4vw, 18px)',
            borderBottom: '1px solid #dee2e6',
            paddingBottom: 'clamp(4px, 1vw, 6px)',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{marginRight: 'clamp(16px, 4vw, 24px)'}}>基本信息</span>
            <div style={{
              display: 'flex',
              gap: 'clamp(16px, 4vw, 24px)',
              fontSize: 'clamp(12px, 2.5vw, 12px)',
              color: '#6c757d',
              marginLeft: 'auto'  // 关键修改：使用auto margin实现右对齐
            }}>
              <div>
                <span>制单人：</span>
                <span>{order.create_name || 'null'}</span>
              </div>
              <div>
                <span>修改人：</span>
                <span>{order.update_name || 'null'}</span>
              </div>
            </div>
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'clamp(8px, 2vw, 12px)',
            fontSize: 'clamp(12px, 3vw, 14px)'
          }} className="print-two-columns">
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>业务流水号：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.flow_no || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>校验码：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.code || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>创建日期：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.code_created_at ? new Date(order.code_created_at).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) : '未记录'}
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>机构名称：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.name || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>机构类型：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.type || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>统一社会信用代码：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.credit_code || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>法定代表人：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.legal_person || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>负责人持股比例：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.share_ratio ? `${order.share_ratio}%` : '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>负责人电话：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.phone || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>机构通信地址：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.address || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>业务类型：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.business_type || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>印章名称：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.seal_names || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>应核验人数：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.should_verify_count ? `${order.should_verify_count}人` : '未设置'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>参与核验人数：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.actual_verify_count ? `${order.actual_verify_count}人` : '0人'}</span>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>是否登报：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.is_announcement === 1 ? '是' : order.is_announcement === 0 ? '否' : '未填写'}
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>见报日期：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.announcement_date ? order.announcement_date.slice(0,10).replace(/-/g,'/') : '未填写'}
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>报刊名称：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.announcement_paper || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>是否有法人股东：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.has_legal_partner === 1 ? '是' : order.has_legal_partner === 0 ? '否' : '未填写'}
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>经办人：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.agent || '未填写'}</span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>经办人电话：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.agent_phone || '未填写'}</span>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>短信接收人：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.sms_receivers ? order.sms_receivers.split('\n').join(', ') : '未设置'}
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '1.4'
              }}>已核验通过股东人数：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.partners?.filter(p => p.face_status === '认证通过').length || 0}人
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '1.4'
              }}>已核验通过股权比例：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>
                {order.verified_share_ratio || '0%'}
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>订单状态：</span>
              <span style={{
                color: order.status === '已结单' ? '#28a745' : '#ffc107',
                fontWeight: '600',
                padding: 'clamp(1px, 0.3vw, 2px) clamp(4px, 1vw, 6px)',
                borderRadius: 'clamp(6px, 1.5vw, 8px)',
                background: order.status === '已结单' ? '#d4edda' : '#fff3cd',
                fontSize: 'clamp(9px, 2vw, 11px)',
                display: 'inline-block',
                maxWidth: 'fit-content',
                whiteSpace: 'nowrap'
              }}>
                {order.status || '未结单'}
              </span>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: 'clamp(12px, 2.5vw, 14px)'
              }}>备注信息：</span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: 'clamp(13px, 3vw, 14px)',
                wordBreak: 'break-all'
              }}>{order.remark || '无'}</span>
            </div>
          </div>
        </div>




        {/* 参与核验人员卡片 */}
        <div style={{
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch'
        }}>
          <div style={{
            background: '#f8f9fa',
            borderRadius: '8px',
            padding: 'clamp(12px, 3vw, 16px)',
            marginBottom: 'clamp(12px, 3vw, 16px)',
            border: '1px solid #e9ecef'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 'clamp(8px, 2vw, 12px)'
            }}>
              <span style={{ fontSize: 'clamp(16px, 4vw, 20px)', marginRight: '8px' }}>👥</span>
              <h3 style={{
                color: '#495057',
                margin: '0',
                fontSize: 'clamp(16px, 4vw, 18px)',
                fontWeight: '600'
              }}>
                参与核验人员
              </h3>

              {/* 注册资金 */}
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>注册资金：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  { `${order.registered_capital} 万元` || '无'}
                </span>
              </div>

            </div>

            

            <div style={{
              display: 'grid',
              gap: '12px'
            }}>
              {order.partners.map(p => (
                  <div
                      key={p.id}
                      style={{
                        background: p.face_status === '认证通过' && p.signStatus === '签名成功' ? '#f8f9fa' : '#fff',
                        border: `2px solid ${p.face_status === '认证通过' && p.signStatus === '签名成功' ? '#dee2e6' : '#e9ecef'}`,
                        borderRadius: '12px',
                        padding: '16px',
                        transition: 'all 0.2s ease',
                        cursor: p.face_status !== '认证通过' || p.signStatus !== '签名成功' ? 'pointer' : 'default',
                        opacity: p.face_status === '认证通过' && p.signStatus === '签名成功' ? 0.7 : 1
                      }}
                      onMouseOver={(e) => {
                        if (p.face_status !== '认证通过' || p.signStatus !== '签名成功') {
                          e.currentTarget.style.borderColor = 'var(--primary-color)';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (p.face_status !== '认证通过' || p.signStatus !== '签名成功') {
                          e.currentTarget.style.borderColor = '#e9ecef';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }
                      }}
                  >
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      gap: '12px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            marginBottom: '8px'
                          }}>
                            <div style={{
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#495057',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              {p.name}
                              {(p.is_legal_person == 1) && (
                                  <span style={{
                                    background: '#dc3545',
                                    color: '#fff',
                                    fontSize: '10px',
                                    padding: '2px 6px',
                                    borderRadius: '8px',
                                    fontWeight: '500'
                                  }}>
                              法人
                            </span>
                              )}
                            </div>
                            <div style={{
                              fontSize: '12px',
                              color: '#6c757d'
                            }}>
                              {p.id_number}
                            </div>
                          </div>

                          {/* 参与人员详细信息 */}
                          <div style={{
                            display: 'flex',
                            gap: '12px',
                            marginTop: '12px',
                            fontSize: '13px'
                          }}>
                            <div style={{
                              padding: '8px 12px',
                              background: '#f8f9fa',
                              borderRadius: '6px',
                              border: '1px solid #e9ecef',
                              flex: '1'
                            }}>
                              <span style={{ color: '#6c757d', fontWeight: '500' }}>出资比例：</span>
                              <span style={{ color: '#495057', fontWeight: '600' }}>
                            {p.share_ratio ? `${p.share_ratio}%` : '未填写'}
                          </span>
                            </div>

                            <div style={{
                              padding: '8px 12px',
                              background: '#f8f9fa',
                              borderRadius: '6px',
                              border: '1px solid #e9ecef',
                              flex: '1'
                            }}>
                              <span style={{ color: '#6c757d', fontWeight: '500' }}>是否法人：</span>
                              <span style={{ color: '#495057', fontWeight: '600' }}>
                            {p.is_legal_person == 1 ? '是' : '否'}
                          </span>
                            </div>
                          </div>

                          {/* 法人单位信息 */}
                          {(p.is_legal_person == 1) && (p.company_name || p.company_credit_code) && (
                              <div style={{
                                marginTop: '8px',
                                padding: '8px',
                                background: '#f8f9fa',
                                borderRadius: '6px',
                                border: '1px solid #e9ecef'
                              }}>
                                <div style={{
                                  fontSize: '11px',
                                  color: '#6c757d',
                                  marginBottom: '4px',
                                  fontWeight: '500'
                                }}>
                                  🏢 法人单位信息
                                </div>
                                {p.company_name && (
                                    <div style={{
                                      fontSize: '11px',
                                      color: '#495057',
                                      marginBottom: '2px'
                                    }}>
                                      单位：{p.company_name}
                                    </div>
                                )}
                                {p.company_credit_code && (
                                    <div style={{
                                      fontSize: '11px',
                                      color: '#495057'
                                    }}>
                                      代码：{p.company_credit_code}
                                    </div>
                                )}
                              </div>
                          )}
                        </div>
                      </div>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 'fit-content',
                        flex: '1',
                        marginLeft: 'auto',
                        gap: '8px'
                      }}>
                        {p.face_status === '认证通过' ? (
                            <>
                              <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '4px'
                              }}>
                          <span style={{
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '600',
                            background: p.signStatus === '签名成功' ? '#28a745' : '#dc3545',
                            color: '#fff',
                            border: p.signStatus === '签名成功' ? '1px solid #28a745' : '1px solid #dc3545'
                          }}>
                            {p.signStatus === '签名成功' ? '认证通过' : moment().diff(moment(p.face_verified_at), 'seconds') <= 0 ? '认证通过' : '认证失败'}
                          </span>
                                {p.face_verified_at && (
                                    <span style={{
                                      fontSize: '10px',
                                      color: '#6c757d',
                                      textAlign: 'center'
                                    }}>
                              {(() => {
                                try {
                                  const date = new Date(p.face_verified_at);
                                  if (isNaN(date.getTime())) {
                                    console.log('Invalid date:', p.face_verified_at);
                                    return p.face_verified_at; // 直接显示原始值
                                  }
                                  return date.toLocaleString('zh-CN');
                                } catch (error) {
                                  console.log('Date parsing error:', error, p.face_verified_at);
                                  return p.face_verified_at; // 直接显示原始值
                                }
                              })()}
                            </span>
                                )}
                                {moment().diff(moment(p.face_verified_at), 'seconds') <= 1 || p.signStatus === '签名成功' ? <span style={{
                                  padding: '4px 12px',
                                  borderRadius: '20px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  background: '#28a745',
                                  color: '#fff',
                                  border: '1px solid #28a745',
                                  cursor: 'pointer'
                                }}>
                            {p.signStatus === '签名成功' ? '签名成功' : moment().diff(moment(p.face_verified_at), 'seconds') <= 1 ? '待签名' : '同意办理'}
                          </span> : null}
                                {p.signTime && p.signStatus === '签名成功' ? (
                                    <span style={{
                                      fontSize: '10px',
                                      color: '#6c757d',
                                      textAlign: 'center'
                                    }}>
                              {(() => {
                                try {
                                  const date = new Date(p.signTime);
                                  if (isNaN(date.getTime())) {
                                    console.log('Invalid date:', p.signTime);
                                    return p.signTime; // 直接显示原始值
                                  }
                                  return date.toLocaleString('zh-CN');
                                } catch (error) {
                                  console.log('Date parsing error:', error, p.signTime);
                                  return p.signTime; // 直接显示原始值
                                }
                              })()}
                            </span>
                                ) : null}
                              </div>
                            </>
                        ) : (
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontSize: '12px',
                              fontWeight: '600',
                              background: p.face_status === '认证失败' ? '#dc3545' : '#ffc107',
                              color: p.face_status === '认证失败' ? '#fff' : '#000',
                              border: `1px solid ${p.face_status === '认证失败' ? '#dc3545' : '#ffc107'}`
                            }}>
                        {p.face_status === '认证失败' ? '❌ 认证失败' : '⏳ 待认证'}
                      </span>
                        )}
                        {/* 签名和签章显示区域 */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                          {p.signUrl && (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ marginBottom: '4px', fontSize: '12px' }}>负责人签字</span>
                                <div
                                    style={{
                                      position: 'relative',
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                      window.open(p.signUrl);
                                    }}
                                >
                                  <img
                                      src={p.signUrl}
                                      alt="签名"
                                      style={{
                                        width: '60px',
                                        height: '30px',
                                        objectFit: 'contain',
                                        border: '1px dashed #ccc',
                                        borderRadius: '4px'
                                      }}
                                  />
                                </div>
                              </div>
                          )}

                          {p.officialSealUrl && (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ marginBottom: '4px', fontSize: '12px' }}>单位盖章</span>
                                <div
                                    style={{
                                      position: 'relative',
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                      window.open(p.officialSealUrl);
                                    }}
                                >
                                  <img
                                      src={p.officialSealUrl}
                                      alt="签章"
                                      style={{
                                        width: '60px',
                                        height: '30px',
                                        objectFit: 'contain',
                                        border: '1px dashed #ccc',
                                        borderRadius: '4px'
                                      }}
                                  />
                                </div>
                              </div>
                          )}
                        </div>
                        {/* 签名和签章显示区域 */}
                      </div>
                    </div>
                  </div>
              ))}
            </div>
          </div>







           {/* 文件列表区域 - 仅添加标题和边框 */}
          <div style={{
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch'
          }}>
            <div style={{
              display: 'grid',
              gap: 'clamp(6px, 1.5vw, 8px)'
            }}>
              <h3 style={{
                color: '#495057',
                paddingTop: '15pX',
                paddingLeft: '15pX',
                fontSize: 'clamp(16px, 4vw, 18px)',
                fontWeight: '600'
              }}>
               未签章文件
              </h3>
              {files && files.length > 0 ? <div style={{
                background: '#fff',
                borderRadius: '12px',
                padding: 'clamp(8px, 2vw, 12px)',
                border: '1px solid #e9ecef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                transition: 'all 0.2s ease'
              }}>
                {files && files.map((item, index) => (
                    <div key={item.fileUrl} style={{
                      width: '100%',
                      padding: '5px 0',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}>
                      <div style={{ flex: '1', fontSize: '12px', fontWeight: '500' }}>
                        {index + 1}、{item.fileName}
                      </div>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px' // 添加按钮间距
                      }}>
                        {/* 下载按钮（蓝色） */}
                        <div
                            style={{
                              padding: '3px 10px',
                              fontSize: '12px',
                              backgroundColor: '#019fe6',
                              color: '#fff',
                              borderRadius: '12px',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              ':hover': {
                                backgroundColor: '#019fe6'
                              }
                            }}
                            onClick={() => {
                              if (item.fileUrl) {
                                // 创建隐藏的下载链接
                                const link = document.createElement('a');
                                link.href = item.fileUrl;
                                link.download = item.fileName || 'download';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } else {
                                setAlert({ open: true, message: '数据错误' });
                              }
                            }}
                        >下载</div>
                        {/* 查看按钮（绿色） */}
                        <div
                            style={{
                              padding: '3px 10px',
                              fontSize: '12px',
                              backgroundColor: '#019fe6',
                              color: '#fff',
                              borderRadius: '12px',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              ':hover': {
                                backgroundColor: '#019fe6'
                              }
                            }}
                            onClick={() => {
                              if (item.fileUrl) {
                                const ext = item.fileUrl.split('.').pop().toLowerCase();
                                const isPdf = ['pdf'].includes(ext);
                                const isWord = ['doc', 'docx'].includes(ext);
                                setFileItemShow(true);
                                if (isPdf) {
                                    setFileType("pdf");
                                } else if (isWord) {
                                    setFileType("docx");
                                }
                               
                              } else {
                                setAlert({ open: true, message: '数据错误' });
                              }
                               setFileItem(item.fileUrl)
                            }}>查看</div>
                      </div>
                    </div>
                ))}
              </div> : null}
            </div>
          </div>
          <div style={{
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch'
          }}>
            <div style={{
              display: 'grid',
              gap: 'clamp(6px, 1.5vw, 8px)'
            }}>
              <h3 style={{
                color: '#495057',
                paddingTop: '15pX',
                paddingLeft: '15pX',
                fontSize: 'clamp(16px, 4vw, 18px)',
                fontWeight: '600'
              }}>
                已签章文件
              </h3>
              {signfiles && signfiles.length > 0 ? <div style={{
                background: '#fff',
                borderRadius: '12px',
                padding: 'clamp(8px, 2vw, 12px)',
                border: '1px solid #e9ecef',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                transition: 'all 0.2s ease'
              }}>
                {signfiles && signfiles.map((item, index) => (
                    <div key={item.fileUrl} style={{
                      width: '100%',
                      padding: '5px 0',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}>
                      <div style={{ flex: '1', fontSize: '12px', fontWeight: '500' }}>
                        {index + 1}、{item.fileName}
                      </div>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px' // 添加按钮间距
                      }}>
                        <div
                            style={{
                              padding: '3px 10px',
                              fontSize: '12px',
                              backgroundColor: '#019fe6',
                              color: '#fff',
                              borderRadius: '12px',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              ':hover': {
                                backgroundColor: '#019fe6'
                              }
                            }}
                            onClick={() => {
                              if (item.fileUrl) {
                                // 创建隐藏的下载链接
                                const link = document.createElement('a');
                                link.href = item.fileUrl;
                                link.download = item.fileName || 'download';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } else {
                                setAlert({ open: true, message: '数据错误' });
                              }
                            }}
                        >下载</div>
                        {/* 查看按钮（绿色） */}
                        <div
                            style={{
                              padding: '3px 10px',
                              fontSize: '12px',
                              backgroundColor: '#019fe6',
                              color: '#fff',
                              borderRadius: '12px',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              ':hover': {
                                backgroundColor: '#019fe6'
                              }
                            }}
                            onClick={() => {
                              if (item.fileUrl) {
                                const ext = item.fileUrl.split('.').pop().toLowerCase();
                                const isPdf = ['pdf'].includes(ext);
                                const isWord = ['doc', 'docx'].includes(ext);
                                setFileItemShow(true);
                                if (isPdf) {
                                    setFileType("pdf");
                                } else if (isWord) {
                                    setFileType("docx");
                                }
                                setFileItem(item.fileUrl)
                              } else {
                                setAlert({ open: true, message: '数据错误' });
                              }
                            }}>查看
                        </div>
                      </div>
                    </div>
                ))}
              </div> : null}
            </div>
          </div>
          {/*文件区结束*/}
        </div>
{/* 弹出框 */}
                {fileItemShow && (
                    <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                    >
                    <div
                        style={{
                        width: "95%",
                        height: "65%",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        overflow: "auto",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        }}
                    >
                        {/* 关闭按钮 */}
                        <div style={{ padding: "10px", textAlign: "right" }}>
                            <text style={{
                            display: 'inline-block',
                            textAlign: 'left',
                            padding: '5px 5px',
                            fontSize: '20px',
                            color: '#888',
                            marginRight: '10vw'
                          }}>💡可放大屏幕阅读</text>
                        <button onClick={() => setFileItemShow(false)}>关闭</button>
                        </div>

                        {/* 文件预览 */}
                        {/* 文件预览 */}
                        <div className="flex-1 overflow-hidden" id='pdfForPreview' ref={pdfForPreview} style={{ flex: 1, borderTop: "1px solid #ccc", height: '100%', width: '100%' }}>
                            { fileType != 'pdf' ? 
                                ( <DocumentFileViewer 
                                    fileUrl={`https://rlrz.cqyz.com.cn/${fileItem}`}
                                    fileType={fileType}
                                    />
                                )
                                : 
                                (
                                    <Worker workerUrl={`${window.location.origin}/pdf.worker.min.js`}>
                                        <Viewer fileUrl={`https://rlrz.cqyz.com.cn/${fileItem}`} />
                                    </Worker>
                                )
                            }
                        </div>
                    </div>
                </div>
                )}
        {/* 操作按钮区域 */}
        <div style={{
          display: 'flex',
          gap: 'clamp(4px, 1vw, 8px)',
          justifyContent: 'center',
          marginTop: 'clamp(20px, 5vw, 30px)',
          paddingTop: 'clamp(12px, 3vw, 20px)',
          borderTop: '1px solid #e9ecef',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          paddingBottom: 'clamp(8px, 2vw, 12px)'
        }}>
          <button
            onClick={onBack}
            style={{
              background: '#6c757d',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
              cursor: 'pointer',
              fontSize: 'clamp(10px, 2.5vw, 12px)',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              minWidth: 'fit-content'
            }}
          >
            返回
          </button>
          <button
            onClick={handlePrint}
            style={{
              background: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
              cursor: 'pointer',
              fontSize: 'clamp(10px, 2.5vw, 12px)',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              minWidth: 'fit-content'
            }}
          >
            打印
          </button>
          {order.status !== '已结单' && (
            <>
              <button
                onClick={() => onEdit(order.id)}
                style={{
                  background: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
                  cursor: 'pointer',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                  minWidth: 'fit-content'
                }}
              >
                编辑
              </button>
              <button
                onClick={handleSendSms}
                style={{
                  background: '#17a2b8',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
                  cursor: 'pointer',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                  minWidth: 'fit-content'
                }}
              >
                发送通知
              </button>
              <button
                onClick={handleCloseOrder}
                disabled={(() => {
                  const verifiedRatio = parseFloat(order.verified_share_ratio?.replace('%', '') || '0');
                  return verifiedRatio < 51;
                })()}
                style={{
                  background: (() => {
                    const verifiedRatio = parseFloat(order.verified_share_ratio?.replace('%', '') || '0');
                    return verifiedRatio < 51 ? '#6c757d' : '#dc3545';
                  })(),
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
                  cursor: (() => {
                    const verifiedRatio = parseFloat(order.verified_share_ratio?.replace('%', '') || '0');
                    return verifiedRatio < 51 ? 'not-allowed' : 'pointer';
                  })(),
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                  minWidth: 'fit-content',
                  opacity: (() => {
                    const verifiedRatio = parseFloat(order.verified_share_ratio?.replace('%', '') || '0');
                    return verifiedRatio < 51 ? 0.6 : 1;
                  })()
                }}
                title={(() => {
                  const verifiedRatio = parseFloat(order.verified_share_ratio?.replace('%', '') || '0');
                  return verifiedRatio < 51 ? '已核验通过股权比例低于51%，无法结单' : '点击结单';
                })()}
              >
                结单
              </button>
            </>
          )}
        </div>



      <SimpleAlert open={alert.open} message={alert.message} onClose={() => setAlert({ ...alert, open: false, onConfirm: null })} onConfirm={alert.onConfirm}/>

      <style jsx>{`
        @media print {
          button {
            display: none !important;
          }
          .print-hide {
            display: none !important;
          }
          @page {
            margin: 1cm;
          }
          body {
            font-size: 12px;
            line-height: 1.4;
          }
        }
      `}</style>
    </div>
  );
}
